import React from "react";
import { Typography } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";

const NoDataMessage = () => {

  return (
    <div
      style={{
        height: '65vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography className="whiteText" style={{ fontSize: 32 }}>
        {getLocalizedString("noUtilsDownloads")}
      </Typography>
    </div>
  );
}

export default NoDataMessage;